import PropTypes from "prop-types";

function TradeFailurePanel({ failures = {} }) {
    const engines = Object.keys(failures || {});

    if (!engines.length) {
        return (
            <div className="text-sm text-gray-300" data-testid="trade-failure-empty">
                No recent trade failures.
            </div>
        );
    }

    return (
        <div className="overflow-x-auto" data-testid="trade-failure-panel">
            <table className="min-w-full text-sm text-left text-gray-200">
                <thead className="text-xs uppercase text-gray-400 border-b border-gray-800">
                    <tr>
                        <th className="py-2 pr-4">Engine</th>
                        <th className="py-2 pr-4">Failures (24h)</th>
                        <th className="py-2 pr-4">Last Time</th>
                        <th className="py-2 pr-4">Reason</th>
                    </tr>
                </thead>
                <tbody>
                    {engines.map((engine) => {
                        const entry = failures[engine] || {};
                        return (
                            <tr key={engine} className="border-b border-gray-800 last:border-b-0">
                                <td className="py-2 pr-4 font-medium text-white">{engine}</td>
                                <td className="py-2 pr-4">{entry.count_24h ?? 0}</td>
                                <td className="py-2 pr-4">{entry.last_failure_time || "-"}</td>
                                <td className="py-2 pr-4">{entry.last_failure_reason || "-"}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

TradeFailurePanel.propTypes = {
    failures: PropTypes.object,
};

export default TradeFailurePanel;
